import * as FilterActions from '../actions/filter.action'
import { IUsageDTO } from '../../utilities/iUsageDTO';

const initialState: IUsageDTO = {
    startDate: new Date(),
    endDate: new Date(),
    lastDel: new Date(),
    nextDel: new Date(),
    daysNextDel: 0,
    daysBTW: 0,
    avgDailyUsage: 0,
    maxDailyUsage: 0,
    dailyVolume: []
  };

export function usageReducer(state: IUsageDTO = initialState, action: FilterActions.Actions) {
  switch (action.type) {
    case FilterActions.SPARKLINE_USAGE:
      return action.payload;
    default:
      return state;
  }
}
